<div class="list-wrapper container-fluid p-0 g-0">
  <div class="row g-0" *ngIf="title !== ''">
    <div class="col">
      <div class="center-text list-title mb-4">
        <h4>{{ title }}</h4>
      </div>
    </div>
  </div>

  <!--Filters-->
  <div class="d-flex align-items-center" *ngIf="filter && filter.filterFields.length > 0">
    <div class="col-12">
      <mat-form-field class="w-100" appearance="outline">
        <mat-icon matSuffix>search</mat-icon>
        <mat-label>{{ filter.filterPlaceholder }}</mat-label>
        <input
          matInput
          [placeholder]="filter.filterPlaceholder"
          autocomplete="off"
          type="text"
          [(ngModel)]="listFilter"
          name="Filter"
          (ngModelChange)="listFilterInputChange($event)"
        />
      </mat-form-field>
    </div>
    <div class="col-6 d-flex justify-content-end">
      <ng-content select="[filterCustom]"></ng-content>
    </div>
  </div>

  <!--Selected action button-->
  <div class="row g-0">
    <div class="col-12 col-sm-4 col-lg-3">
      <a
        class="w-100"
        mat-flat-button
        color="accent"
        (click)="emitSelectedItemsAction()"
        *ngIf="selectable"
        [matTooltip]="selectedItemsButtonText"
        matTooltipPosition="below"
        matTooltipShowDelay="1000"
      >
        {{ selectedItemsButtonText }}
      </a>
    </div>
  </div>

  <div class="row g-0 table-container">
    <div class="loading-shade" *ngIf="loading">
      <mat-spinner></mat-spinner>
    </div>

    <div class="col">
      <!--Top Pagination-->
      <mat-paginator
        *ngIf="listToDisplay.length > 0 && pagination.topPagination && !loading"
        showFirstLastButtons
        [length]="totalElements"
        [pageSize]="pagination.elementsPerPage"
        (page)="handlePageChange($event)"
        [pageIndex]="currentPage - 1"
        [hidePageSize]="true"
      >
      </mat-paginator>

      <table mat-table [dataSource]="listToDisplay" class="data w-100 list-table">
        <!-- Columns -->
        <ng-container *ngFor="let field of displayFields" [matColumnDef]="field.name">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="field?.headerStyle">
            <span *ngIf="field.type != 'checkbox'">
              <span *ngIf="field.type == 'custom'"></span>
              <span *ngIf="field.type != 'custom'" class="names">{{ field.name }}</span>
            </span>

            <mat-checkbox *ngIf="field.type == 'checkbox'" [checked]="selectAllCheckbox" (change)="checkAllItems()">
            </mat-checkbox>

            <mat-icon
              class="pt-2"
              [matTooltip]="'list.order_tooltip' | translate: { value: field.name }"
              matTooltipPosition="right"
              matTooltipShowDelay="1000"
              *ngIf="sortableFields.includes(field.name) && currentField == field.property && currentDirection == 1"
              (click)="orderColumn(field.property, -1)"
              >expand_less</mat-icon
            >

            <mat-icon
              class="pt-2"
              [matTooltip]="'list.order_tooltip' | translate: { value: field.name }"
              matTooltipPosition="right"
              matTooltipShowDelay="1000"
              *ngIf="sortableFields.includes(field.name) && currentField == field.property && currentDirection == -1"
              (click)="orderColumn('', 0)"
              >expand_more</mat-icon
            >

            <mat-icon
              class="pt-2"
              [matTooltip]="'list.order_tooltip' | translate: { value: field.name }"
              matTooltipPosition="right"
              matTooltipShowDelay="1000"
              *ngIf="sortableFields.includes(field.name) && currentField != field.property"
              (click)="orderColumn(field.property, 1)"
              >remove</mat-icon
            >
          </th>

          <td
            mat-cell
            *matCellDef="let item"
            [ngStyle]="item['contentStyle'][field.property]"
            matTooltipPosition="right"
            matTooltip="{{ field.truncate ? resolveObjectProperty(item, field.property) : '' }}"
          >
            <mat-checkbox
              *ngIf="field.type == 'checkbox'"
              [checked]="item['selected']"
              (change)="checkboxChanged(item)"
            >
            </mat-checkbox>

            <ng-container *ngIf="field.type == 'string'">
              <span
                class="string-field"
                [ngStyle]="field?.edit?.contentStyle"
                *ngIf="
                  field.edit &&
                    (resolveObjectProperty(item, field.edit.property) ||
                      resolveObjectProperty(item, field.edit.property) == 0);
                  else elseBlock
                "
                matTooltip="{{
                  field.name +
                    ': ' +
                    (resolveObjectProperty(item, field.property) || resolveObjectProperty(item, field.property) == 0
                      ? resolveObjectProperty(item, field.property)
                      : '-')
                }}"
              >
                {{ resolveObjectProperty(item, field.edit.property) }}</span
              >
              <ng-template #elseBlock>
                <div *ngIf="field.truncate; else spanBlock" class="string-field truncate-div">
                  {{ resolveObjectProperty(item, field.property) }}
                </div>
                <ng-template #spanBlock>
                  <span class="string-field">
                    {{ resolveObjectProperty(item, field.property) }}
                  </span>
                </ng-template>
              </ng-template>
            </ng-container>

            <span
              class="{{ field.style['font_bold'] | boolean: 'true':'font_bold':'font_normal' }} {{
                field.style['upper'] | boolean: 'true':'font_upper':''
              }}"
              *ngIf="field.type == 'datetime'"
            >
              {{ resolveObjectProperty(item, field.property) | date: 'd-MMM-y, hh:mm':undefined:'it' }}</span
            >

            <span
              class="{{ field.style['font_bold'] | boolean: 'true':'font_bold':'font_normal' }} {{
                field.style['upper'] | boolean: 'true':'font_upper':''
              }}"
              *ngIf="field.type == 'date'"
            >
              {{
                resolveObjectProperty(item, field.property) | date: field.style['format_date']:'undefined':'it'
              }}</span
            >

            <ng-container *ngIf="field.type == 'number'">
              <span
                class="string-field"
                [ngStyle]="field?.edit?.contentStyle"
                *ngIf="
                  field.edit &&
                    (resolveObjectProperty(item, field.edit.property) ||
                      resolveObjectProperty(item, field.edit.property) == 0);
                  else elseBlock
                "
                matTooltip="{{
                  field.name +
                    ': ' +
                    (resolveObjectProperty(item, field.property) || resolveObjectProperty(item, field.property) == 0
                      ? resolveObjectProperty(item, field.property)
                      : '-')
                }}"
                >{{ resolveObjectProperty(item, field.edit.property) | number: '1.0-0' }}</span
              >
              <ng-template #elseBlock>
                <span
                  class="{{ field.style['font_bold'] | boolean: 'true':'font_bold':'font_normal' }} {{
                    field.style['upper'] | boolean: 'true':'font_upper':''
                  }}"
                  >{{ resolveObjectProperty(item, field.property) | number: '1.0-0' }}</span
                >
              </ng-template>
            </ng-container>

            <span
              *ngIf="field.type == 'boolean'"
              class="{{ field.style['font_bold'] | boolean: 'true':'font_bold':'font_normal' }} {{
                field.style['upper'] | boolean: 'true':'font_upper':''
              }} {{
                resolveObjectProperty(item, field.property)
                  | boolean: field.style['control']:'boolean_vis_true':'boolean_vis_false'
              }}"
              ><span class="boolean_text">{{
                resolveObjectProperty(item, field.property)
                  | boolean
                    : field.style['control']
                    : resolveObjectProperty(item, field.style['true'])
                    : resolveObjectProperty(item, field.style['false'])
              }}</span></span
            >

            <div class="px-1" *ngIf="field.type == 'custom'">
              <ng-container
                *ngIf="customFieldTemplateRef"
                [ngTemplateOutlet]="customFieldTemplateRef"
                [ngTemplateOutletContext]="{ $implicit: item }"
              >
              </ng-container>
            </div>

            <div *ngIf="field.type == 'custom-with-template'">
              <ng-container
                *ngIf="field.templateRef"
                [ngTemplateOutlet]="field.templateRef"
                [ngTemplateOutletContext]="{ $implicit: item, property: field.property }"
              >
              </ng-container>
            </div>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns"
          [ngClass]="{ 'hidden-headers': listToDisplay.length == 0 }"
        ></tr>

        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          class="on_hover_bg"
          [ngClass]="{ 'clickable-row': clickableRows, 'row-selected': row['selected'] }"
          (click)="rowClickedEmit(row)"
          (mouseenter)="mouseEnterEmit(row)"
          (mouseleave)="mouseLeaveEmit(row)"
        ></tr>

        <tr *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length">
            <h5 class="mt-4 mb-3 text-center">{{ 'common.no_data' | translate }}</h5>
          </td>
        </tr>
      </table>

      <!--Bottom Pagination-->
      <mat-paginator
        *ngIf="listToDisplay.length > 0 && pagination.bottomPagination && !loading"
        showFirstLastButtons
        [length]="totalElements"
        [pageSize]="pagination.elementsPerPage"
        (page)="handlePageChange($event)"
        [pageIndex]="currentPage"
        [hidePageSize]="true"
      >
      </mat-paginator>
    </div>
  </div>
</div>
